import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import EditUser from './edit_form';
import { ReactComponent as EditIcon } from 'assets/images/SVG/icons/edit-icon.svg';
import { SpanButton } from 'component/button_components/button.style';
import { useDispatch, useSelector } from 'react-redux';
import { getOneUser } from 'redux/slices/createUser';
import { SweetSweetAlert } from 'component/sweetalert_components';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';

export default function EditUserModal({ ...record }) {
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [singleUserData, setSingleUserData] = useState(null);
  const dispatch = useDispatch();
  const selectedNode = useSelector((state) => state.selectedNode);

  const showModal = async () => {
    try {
      setLoader(true);
      const sweetAlert = await dispatch(
        getOneUser({ userName: record.dn, fqdn: selectedNode.domainName, domainId: selectedNode.currentdomainId })
      );
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        setSingleUserData(sweetAlert.payload.data);
        setOpen(true);
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    } finally {
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setLoader(false);
  };
  return (
    <>
      <Tooltip title='Edit' color='#597081' className='af-user-edit-tooltip'>
        <SpanButton onClick={showModal} className='af-user-edit-tooltip-button'>
          <EditIcon className='af-user-edit-tooltip-icon' />
        </SpanButton>
      </Tooltip>
      {loader && <ModalOpenLoader />}
      {open && (
        <Modal
          open={open}
          maskClosable={false}
          onCancel={handleCancel}
          footer={false}
          centered
          width={800}
          className='modal-style af-user-edit-modal'
        >
          <EditUser {...record} singleUserData={singleUserData} handleCancel={handleCancel} />
        </Modal>
      )}
    </>
  );
}
